import * as React from "react";
import { Button, Row } from "components/bootstrap";
import Routes from "routing/Routes";
import useInputSetupWizard from "components/inputs/InputSetupWizard/hooks/useInputSetupWizard";
import { StepWrapper, DescriptionCol, ButtonCol } from "./components/StepWrapper";
const InputDiagnosisStep = ({ onClose }) => {
  const {
    wizardData: { input }
  } = useInputSetupWizard();
  return /* @__PURE__ */ React.createElement(StepWrapper, null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(DescriptionCol, { md: 12 }, /* @__PURE__ */ React.createElement("p", null, "Test inputs and parsing without writing any data to the search cluster."))), (input == null ? void 0 : input.id) && /* @__PURE__ */ React.createElement(
    Button,
    {
      bsSize: "xs",
      bsStyle: "primary",
      onClick: () => window.open(Routes.SYSTEM.INPUT_DIAGNOSIS(input == null ? void 0 : input.id), "_blank")
    },
    "Go to Input Diagnosis"
  ), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(ButtonCol, { md: 12 }, /* @__PURE__ */ React.createElement(Button, { onClick: onClose }, "Finish"))));
};
export default InputDiagnosisStep;
